import { cPlanDiscountedPrice } from '../mdl/c-plan';
import { FPageHeroBlock, FPageNewHeroBlock, FPageSubscribeButtonBlock } from '../mdl/f-page-block';
import { getCountry } from '../me/me';
import { UIButton } from '../ui/component/button';
import { $el } from '../ui/elements';
import { $format } from '../y/format';
import { yGetI18N, yInterpolate } from '../y/i18n';
import { $location } from '../y/location';
import { blkRegister } from './registry';
import { makePageBlock } from './render';

blkRegister<FPageSubscribeButtonBlock>('subscribe_button', b => {
    const promo = window.tl_signup_promo;

    const standard = window.tl_plans[0];
    const standard_base_price = $format.currency(standard.price[getCountry()]);
    const standard_discounted_price = $format.currency(cPlanDiscountedPrice(standard, promo));
    const plusone = window.tl_plans[1];
    const plusone_base_price = $format.currency(plusone.price[getCountry()]);
    const plusone_discounted_price = $format.currency(cPlanDiscountedPrice(plusone, promo));

    return $el.DIV('blk-subscribebutton', [
        b.symbol && $el.DIV('sym sym-' + b.symbol),
        $el.DIV('r-button', [
            new UIButton({
                title: yInterpolate(yGetI18N(promo.texts.hero_button), standard_base_price, standard_discounted_price, plusone_base_price, plusone_discounted_price), kind: 'k-shadow', classes: 'ui-tint-blue', on_click: () => {
                    $location.navigate(['signup'], { origin: 'header_button' });
                }
            }),
            $el.DIV('r-sub', yInterpolate(yGetI18N(promo.texts.hero_subtitle), standard_base_price, standard_discounted_price, plusone_base_price, plusone_discounted_price)),
        ]),
    ]);
});

blkRegister<FPageHeroBlock>('hero', (b, section, promises, id, page_flags) => {
    return $el.DIV('blk-hero', [
        $el.fromEditedHtml(b.top, 'r-text'),
        !b.no_signup && $el.DIV('r-container', [
            makePageBlock({ type: 'app_rating', split: false }, section, promises, id, page_flags),
            makePageBlock({ type: 'subscribe_button' }, section, promises, id, page_flags),
        ]),
        b.no_signup && $el.fromEditedHtml(b.bottom, 'r-text')
    ]);
});

blkRegister<FPageNewHeroBlock>('new_hero', (b, section, promises, id, page_flags) => {
    const block = $el.DIV('blk-hero b b-block', $el.DIV('r-container', b.blocks.map(bb => makePageBlock(bb, section, promises, id, page_flags))));
    return block;
});
